// import Modal from "./modules/Modal.js";
// import Button from "./modules/Button.js";
import SmoothScroll from "./modules/SmoothScroll.js";
import Accordion from "./modules/Accordion.js";
import Menu from "./modules/Menu.js";
import Breakpoints from "./modules/Breakpoints.js";

// new Modal();
// new Button();

new Menu();
new SmoothScroll();
const breakpoints = new Breakpoints();
if(document.querySelector('[data-accordion="qa"]')) {
  const qaAccordion = new Accordion('[data-accordion="qa"]');
}
if(document.querySelector('[data-accordion="point"]')) {
  const pointAccordion = new Accordion('[data-accordion="point"]', true);
}

const mySwiper = new Swiper('.js-my-swiper', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 15,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    769: {
      slidesPerView: 2,
      loopAdditionalSlides: 1,
      spaceBetween: 30,
    },
  },
});

let cardSwiper;
const initCardSwiper = () => {
  cardSwiper = new Swiper('.js-card-swiper', {
    slidesPerView: 1.165,
    spaceBetween: 32,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    }
  });
}
const destroyCardSwiper = () => {
  if (cardSwiper) {
    cardSwiper.destroy();
    cardSwiper = undefined;
  }
}
const handleResizeCardSwiper = () => {
  if (breakpoints.up('md').matches) {
    destroyCardSwiper();
  } else {
    initCardSwiper();
  }
}
handleResizeCardSwiper();
breakpoints.up('md').addEventListener('change', () => {
  handleResizeCardSwiper();
});


